import { Tooltip } from "@mui/material";
import noImage from "assets/images/no-image.png";
import Button from "components/common/Button";
import { baseURL } from "config/api";
import { useAppSelector } from "hooks/store";
import { useState, useRef, useEffect } from "react";
type Props = any;

const Product = (props: Props) => {
  const { settings, deliveryType } = useAppSelector(({ main }) => main);
  const [loading, setLoading] = useState(true);
  const [isExpanded, setIsExpanded] = useState(false);
  const [isExpandedpricedec, setIsExpandedpricedec] = useState(false);

  const toggleDescription = () => setIsExpanded((prev) => !prev);
  const togglePriceDescription = () => setIsExpandedpricedec((prev) => !prev);
  return (
    <div
      className="bg-white shadow-lg max-w-lg overflow-hidden border border-gray-200 rounded-3xl flex flex-col h-[260px]" //
    >
      <div className="flex flex-1 flex-row px-4 pt-4">
        <div className="flex-[2] pr-4 flex flex-col justify-between">
          {/* Title and Description */}
          <div>
            <Tooltip title={props.productName}>
              <h3 className="font-bold text-lg mb-1 text-itemColor line-clamp-2">
                {props.productName}
              </h3>
            </Tooltip>

            <Tooltip title={props.productDescription}>
              <p className={`text-sm text-gray-700  break-words line-clamp-2`}>
                {props.productDescription}
              </p>
            </Tooltip>

            {/* {props.productDescription.length > 50 && (
              <span
                className="text-primary text-xs underline"
                onClick={(e) => {
                  e.stopPropagation();
                  toggleDescription();
                }}
              >
                {isExpanded ? "Less" : "More"}
              </span>
            )} */}
            {/* Add-ons Section */}
            {props.pricedesc && props.pricedesc !== "0" && (
              <div className="space-y-1 text-xs text-black bg-gray-200 shadow-md p-2 mt-2">
                <Tooltip
                  title={
                    props.pricedesc && props.pricedesc !== "0"
                      ? props.pricedesc
                      : `$${props.price}`
                  }
                >
                  <p
                    className={`text-sm text-gray-700  break-words line-clamp-2`}
                  >
                    {props.pricedesc && props.pricedesc !== "0"
                      ? props.pricedesc
                      : `$${props.price}`}
                  </p>
                </Tooltip>
                {/* {props.pricedesc.length > 30 && (
                  <span
                    className="text-primary text-xs underline"
                    onClick={(e) => {
                      e.stopPropagation();
                      togglePriceDescription();
                    }}
                  >
                    {isExpandedpricedec ? "Less" : "More"}
                  </span>
                )} */}
              </div>
            )}
          </div>
        </div>

        {props.imageUrl && (
          <div className="flex-1 pl-1">
            {loading && (
              <div className="flex justify-center items-center w-full h-auto min-h-[100px] min-w-[100px] max-h-[200px] max-w-[200px] md:max-h-[250px] md:max-w-[250px] lg:max-h-[300px] lg:max-w-[300px] aspect-square rounded-3xl border-4 border-gray-200 object-cover  ">
                <div className="w-10 h-10  border-4 border-gray-300 border-t-primary rounded-full animate-spin"></div>
              </div>
            )}

            <img
              src={props.imageUrl || noImage}
              className={`w-full h-auto min-h-[100px] min-w-[100px] max-h-[200px] max-w-[200px] md:max-h-[250px] md:max-w-[250px] lg:max-h-[300px] lg:max-w-[300px] aspect-square rounded-3xl border-4 border-gray-200 object-cover ${
                loading ? "hidden" : "block"
              }`}
              onLoad={() => setLoading(false)}
              onError={(e) => {
                e.currentTarget.src = noImage;
                setLoading(false);
              }}
            />
          </div>
        )}
      </div>

      {/* Price and Add Cart Button */}
      <div className="flex items-center justify-center pt-1 px-4 pb-4">
        <div
          className={`flex flex-row ${
            !!props.price ? "justify-between" : "justify-center"
          } items-center bg-gray-50 rounded-xl p-2 shadow-md w-full sm:w-[80%] max-w-sm text-center`}
        >
          {settings.ApplyTakeOutDeliveryPrice !== 0 ? (
            <>
              {deliveryType !== "pickup" ? (
                <span className="text-base md:text-lg font-bold bg-gray-200 px-2 py-1 rounded-lg text-pricetextcolor">
                  $
                  {props?.deliveryprice === 0
                    ? props.price.toFixed(2)
                    : props?.deliveryprice.toFixed(2)}
                </span>
              ) : (
                <span className="text-base md:text-lg font-bold bg-gray-200 px-2 py-1 rounded-lg   text-pricetextcolor">
                  $
                  {props?.takeoutprice === 0
                    ? props.price.toFixed(2)
                    : props?.takeoutprice.toFixed(2)}
                </span>
              )}
            </>
          ) : (
            <>
              {!!props.price && (
                <span className="text-base md:text-lg font-bold bg-gray-200 px-2 py-1 rounded-lg  text-pricetextcolor">
                  ${props.price.toFixed(2)}
                </span>
              )}
            </>
          )}
          <Button
            className="bg-primary text-themeSelColor text-xs md:text-sm lg:text-base rounded-lg "
            onClick={props.onClick}
          >
            {props.btnText}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Product;
